<template>
<div class="odr-upload">
    <drag-file ref="dragFile"
               :input="input"
               :width="180"
               :height="135"
               :lastpass="lastpass"
               :icon="'attach_file'"
               :accept="accept"
               @focus="$emit('focus')"
               @blur="$emit('blur')"
               @changed="data => {input = data.result; filename = data.filename}"/>

    <div :style="`width: 200px !important;`">
        <linearProgress v-if="fileUpload_inProgress"/>
    </div>
    <text-regular v-if="fileUpload_failed" color="error">{{ $trl('aw.upload_image_invalid') }}</text-regular><br>
    <text-link v-if="fileUpload_failed"
               bold="true"
               color="error"
               @click="retry">
        {{ $trl('aw.upload_image_retry') }}
    </text-link>

    <gap top="single">
        <button v-if="!input"
                ref="choose"
                class="odr-button-link odr-button-link_bold odr-button-link_no-padding"
                type="button"
                @focus="() => {$emit('focus')}"
                @blur="() => {$emit('blur')}"
                @click="selectFile">
            {{ $trl('aw.choose') }}
        </button>

        <button v-if="input"
                type="button"
                class="odr-button-link odr-button-link_bold"
                @focus="() => {$emit('focus')}"
                @blur="() => {$emit('blur')}"
                @click="clear">
            {{ $trl('aw.remove') }}
        </button>
    </gap>
    <div v-if="validation_showError && validation_error"
         class="odr-error-message"
         :class="{
             'odr-error-message_plain': $root.appConfig.mode !== 'chat'
         }">
        {{ validation_error }}
    </div>
</div>
</template>

<script>
import '@/scss/blocks/button-link.scss';
import '@/scss/blocks/error-message.scss';
import '@/scss/blocks/upload.scss';

import { dataURItoBlob } from '@/utils/blob';
import validationMixin from '@/utils/mixins/validation';
import fileUploadMixin from '@/utils/mixins/file-upload';
import focusMixin from '@/utils/mixins/focus';

export default {
    mixins: [validationMixin, fileUploadMixin, focusMixin],
    props: {
        stateId: {},
        dataQa: {},
        value: {},
        title: {},
        accept: {},
        lastpass: {
            type: Boolean,
        },
    },
    data () {
        return {
            filename: null,
            input: this.value,
        };
    },
    computed: {
        eInput () {
            if (this.uploadToken) {
                return this.fileUpload_succeed ? { token: this.uploadToken, base64: this.input, filename: this.filename } : '';
            } else {
                return { base64: this.input, filename: this.filename };
            }
        },
    },
    watch: {
        input () {
            this.validation_changed();

            if (this.uploadToken) {
                this.fileUpload_send(dataURItoBlob(this.input));
            }
        },
        eInput () {
            this.$emit('input', this.eInput);
        },
    },

    methods: {
        retry () {
            this.fileUpload_send(dataURItoBlob(this.input));
        },
        focus_focus () {
            if (this.$refs.dragFile && this.$refs.dragFile.$refs.file) {
                this.$refs.dragFile.$refs.file.focus({ preventScroll: true });
            }
        },
        validation_isEmpty () {
            return !this.eInput;
        },
        clear () {
            this.input = null;
            this.filename = null;
        },
        selectFile () {
            this.$refs.dragFile.$refs.file.click();
        },
        validation_invalid () {
            return this.fileUpload_inProgress;
        },
    },
    components: {
        linearProgress: require('@/vue/markup/linear-progress.vue').default,
        'drag-file': require('@/vue/components/drag-file.vue').default,
        gap: require('@clearwave/odoro-markup/lib/vue/gap.vue').default,
        'text-link': require('@clearwave/odoro-markup/lib/vue/text-link.vue').default,
        'text-regular': require('@clearwave/odoro-markup/lib/vue/text-regular.vue').default,
    },
};
</script>
